<div class="wrapper wrap" *ngIf="configChecked">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1 class="pageTitle">
          <span *ngIf="!serviceUnavailableContent.title">Service currently unavailable</span>
          <span *ngIf="serviceUnavailableContent.title">{{ serviceUnavailableContent.title}}</span>
        </h1>
        <p *ngIf="!serviceUnavailableContent.message">We are currently experiencing connection issues. We apologise for the inconvenience. Please try again later.</p>
        <div *ngIf="serviceUnavailableContent.message" [innerHTML]="serviceUnavailableContent.message"></div>
      </div>
    </div>
  </div>
</div>